<template>
  <el-container>
    <main class="page__container">
      <div class="container">
        <h2 class="page__title">Добавить юридическое лицо</h2>
        <el-form
          class="page__form"
          id="formCreateOrg"
          :model="org"
          ref="form"
          :rules="rules"
          label-position="right"
          label-width="150px"
        >
          <el-form-item label="Название" prop="org_name">
            <el-input id="org_name" size="small" v-model="org.org_name" />
          </el-form-item>
        </el-form>
      </div>
    </main>
    <el-footer class="page__active_bar">
      <el-button class="page__active_button" id="submit" icon="el-icon-check" type="primary" @click="submit">
        Добавить
      </el-button>
    </el-footer>
  </el-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { required, length } from "@/core/helpers/validators";

export default {
  name: "FormCreateOrg",
  data() {
    return {
      org: {
        org_name: "",
      },
      rules: {
        org_name: [required(), length(2, 100)],
      },
    };
  },
  created() {
    this.getParameters();
  },
  methods: {
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.create(this.org)
            .then((id) => {
              this.$message({
                message: "Юридическое лицо успешно создано",
                type: "success",
              });
              this.$router.push({ name: "org:edit", params: { id } });
            })
            .catch((e) => {
              this.$message.error(e.response.data.error || "Ошибка при добавлении юридического лица");
            });
        }
        return valid;
      });
    },
    ...mapActions("org", {
      create: "ADD_ORG",
      getParameters: "GET_OPERATOR_PARAMETERS",
    }),
  },
};
</script>
